var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { loading } from 'elements/Loading';
import theme from 'Theme';
import IconosApp, { Icono } from 'elements/IconosApp';
import cxs from 'cxs/component';
import Theme from '../../../Theme';
import History from '../../../helpers/History';
import { TypeTicket } from '../../Detail/DetailRoutes';
let StretchesList = class StretchesList extends Component {
    constructor() {
        super(...arguments);
        this.handleSelectItem = (value, type) => {
            let toShow;
            if (!type || type === TypeTicket.Stretch) {
                toShow = 'stretches';
            }
            else if (type === TypeTicket.Packet) {
                toShow = 'packets';
            }
            else {
                this.props.store.UI.newError('Error code 700');
            }
            history.push(`/detail/${toShow}/${value.id}`);
        };
        this.mapea = (values, operationlineId) => {
            return values.filter((stretch) => {
                return stretch.operationLine_id === operationlineId;
            });
        };
    }
    componentDidMount() {
        const hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        // console.log('StretchesList - componentDidMount - hasParent', hasParent)
        this.props.store.UI.changeHasParent(hasParent);
    }
    render() {
        const { stretchesStore, operationLines, packetsStore } = this.props.store;
        const operationlineId = Number(this.props.match.params.id);
        console.log('operationlineId: ', operationlineId);
        const type = this.props.typeList;
        let mapeados;
        if (type === TypeTicket.Stretch) {
            mapeados = this.mapea(stretchesStore.data, operationlineId);
        }
        else if (type === TypeTicket.Packet) {
            mapeados = this.mapea(packetsStore.data, operationlineId);
        }
        if (this.props.searchTerm) {
            mapeados = mapeados.filter((value) => value.name.toLowerCase().includes(this.props.searchTerm.toLowerCase()));
        }
        // console.log('mapeados', mapeados)
        if (!(operationLines.data.length > 0))
            return (React.createElement("div", null,
                React.createElement("text", null, "No hay lineas de operaci\u00F3n, por favor cree una antes")));
        return (React.createElement("div", { style: {
                maxHeight: `${theme.common.devices.desktopHeight}px`,
                justifyContent: 'center',
                paddingLeft: '10px',
                paddingRight: '10px',
            } }, mapeados.map((item, index) => (React.createElement(Wrapper, { key: item.name, onClick: () => this.handleSelectItem(item, type), style: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                /*margin: '30px',*/
                height: '90px',
                borderBottom: index !== mapeados.length - 1
                    ? `1px solid ${theme.color.hairline}`
                    : undefined,
            } },
            !item.image && (React.createElement(IconosApp, { style: {
                    flex: 1,
                    fontSize: '50px',
                }, name: Icono[item.icon] })),
            item.image && (React.createElement("img", { src: item.image, alt: `imagen ${item.name}`, style: {
                    height: '70px',
                } })),
            React.createElement(StyledP, null, item.name))))));
    }
};
StretchesList = __decorate([
    inject('store'),
    observer,
    loading((props) => {
        return [
            props.store.stretchesStore.read(),
            props.store.packetsStore.read(),
            props.store.operationLines.read(),
        ];
    })
], StretchesList);
export default StretchesList;
const Wrapper = cxs('div')(() => ({
    ':hover': {
        color: Theme.color.primary,
    },
}));
const StyledP = cxs('p')(({ hover }) => ({
    flex: 2,
    textAlign: 'center',
    margin: 0,
}));



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/StretchesList.tsx
// module id = 543
// module chunks = 0